<template>
    <DefaultLayout>
        <!-- should be the take-5-daily layout here -->
        <slot />
    </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from '~/layouts/default.vue'

</script>